const unlocalizedPages = ['blog', 'sr', 'legal'];

const regexFirstPathElement = /^\/([^/]*)/;
const regexHelpCenterSupportPage = /^\/en\/support\//;

function getFirstPathElement(path) {
    return path.match(regexFirstPathElement)[1];
}

function unlocalizedPageCheck(path) {
    if (!path || path.includes('/blog/pressroom')) {
        return true;
    }

    if (regexHelpCenterSupportPage.test(path)) {
        return true;
    }

    let firstPathEl = getFirstPathElement(path);

    return unlocalizedPages.includes(firstPathEl);
}

exports.unlocalizedPages = unlocalizedPages;
exports.regexFirstPathElement = regexFirstPathElement;
exports.regexHelpCenterSupportPage = regexHelpCenterSupportPage;
exports.getFirstPathElement = getFirstPathElement;
exports.unlocalizedPageCheck = unlocalizedPageCheck;
